import Individual from "./individual/SpotifyStatistics";

export default { Individual };
